import { Button, Typography } from "@mui/material";
import ToolTip from "../../ToolTip/ToolTip";

const handleAssign = (params) => {
  return (
    <ToolTip content={params.row.description || "N/A"} expand={params.row.description} />
  );
};

export const Product_Table_Head = [
  {
    field: "sl_no",
    headerName: "Sl No",
  },
  {
    field: "product_name",
    headerName: "Product Name",
    width: 200,
  },
  {
    field: "category_name",
    headerName: "Category Name",
    width: 350,
    valueGetter: (params) => params.row.category?.category_name || "N/A",
  },
  {
    field: "brand_name",
    headerName: "Brand Name",
    width: 200,
    valueGetter: (params) => params.row.brand?.brand_name || "N/A",
  },

  // {
  //   field: "stock_quantity",
  //   headerName: "Stock Quantity",
  //   width: 200,
  // },
  // {
  //   field: "minimum_stock_quantity",
  //   headerName: "Minimum Stock",
  //   width: 200,
  // },
  // {
  //   field: "purchase_price",
  //   headerName: "Purchase Price",
  //   width: 200,
  // },
  // {
  //   field: "sale_price",
  //   headerName: "Sale Price",
  //   width: 200,
  // },
  {
    field: "description",
    headerName: "Description",
    width: 200,
    renderCell: handleAssign,
  },
  // {
  //   field: "product_serial_number",
  //   headerName: "Serial Number",
  //   width: 200,
  // },
  // {
  //   field: "product_status",
  //   headerName: "Product Status",
  //   width: 200,
  //   renderCell: (params) => {
  //     if (params.row.product_status === 1) {
  //       return (
  //         <Button
  //           sx={{
  //             color: "green",
  //             border: "1px solid green",
  //             background: "none",
  //             borderRadius: "5px",
  //             px: "5px",
  //           }}
  //         >
  //           In Stock
  //         </Button>
  //       );
  //     }
  //     if (params.row.product_status === 2) {
  //       return (
  //         <Button
  //           sx={{
  //             color: "red",
  //             border: "1px solid red",
  //             background: "none",
  //             borderRadius: "5px",
  //             px: "8px",
  //           }}
  //         >
  //           Out Of Stock
  //         </Button>
  //       );
  //     }
  //     return "N/A";
  //   },
  // },
];
